
<b-row>
  <TextField
    v-model="user.name"
    name="name"
    :label="__('common.name')"
    class="col-md-5"
    required
  />

  <TextField
    v-model="user.email"
    name="email"
    :label="__('common.email')"
    class="col-md-4"
  />

  <SelectField
    v-model="user.defaultEntityId"
    name="default_entity_id"
    :label="__('common.entity')"
    class="col-md-3"
    required
    :readonly="isReadOnly"
    :options="entities"
    @onChange="onEntityChange"
  />

  <SelectField
    v-model="user.roles"
    name="roles[]"
    :label="__('roles.roles')"
    class="col-md-4"
    :options="roles"
    multiple
  />

  <TextField
    v-model="user.position"
    :label="__('users.position')"
    class="col-md-3"
    name="position"
  />

  <TextField
    v-model="user.phone"
    name="phone"
    :label="__('common.phone')"
    class="col-md-4"
  />

  <SelectField
    v-model="user.specialities"
    name="specialities[]"
    :label="__('users.specialities')"
    class="col-md-4"
    :options="UserModel.specialities()"
    multiple
  />

  <TextField
    v-model="user.mobile"
    name="mobile"
    :label="__('common.mobile')"
    class="col-md-4"
  />

  <SelectField
    v-model="user.notificationChannels"
    name="notification_channels[]"
    :label="__('notifications.popover-title')"
    class="col-md-3"
    :options="UserModel.notificationChannels()"
    multiple
  />

  <TextField
    v-model="user.addressHouse"
    name="address_house"
    :label="__('address.house')"
    class="col-md-2"
  />

  <TextField
    v-model="user.addressUnit"
    name="address_unit"
    :label="__('address.unit')"
    class="col-md-2"
  />

  <TextField
    v-model="user.addressStreet"
    name="address_street"
    :label="__('address.street')"
    class="col-md-4"
  />

  <TextField
    v-model="user.addressTown"
    name="address_town"
    :label="__('address.town')"
    class="col-md-4"
  />

  <TextField
    v-model="user.addressPostCode"
    name="address_post_code"
    :label="__('address.post-code')"
    class="col-md-3"
  />

  <SelectField
    v-model="user.addressCountry"
    name="address_country"
    :label="__('address.country')"
    class="col-md-4"
    required
    autocomplete="off"
    :options="translatedCountries"
    @onChange="fetchCounties"
  />

  <SelectField
    v-if="user.addressCountry && counties.length"
    v-model="user.addressCounty"
    :options="counties"
    name="address_county"
    :label="__('address.county')"
    class="col-md-3"
  />

  <TextField
    v-else
    v-model="user.addressCounty"
    name="address_county"
    :label="__('address.county')"
    class="col-md-3"
  />

  <SelectField
    v-model="user.language"
    :options="languages"
    name="language"
    required
    :label="__('common.language')"
    class="col-md-3"
  />

  <b-col v-if="!user.id" cols="12">
    <hr />
  </b-col>

  <EditorField
    v-model="user.emailSignature"
    name="email_signature"
    :label="__('email.signature')"
    class="col-12"
    :editor-options="editorOptions"
    height="250px"
  />

  <TextAreaField
    v-model="user.notes"
    name="notes"
    :label="__('common.notes')"
    :description="__('users.notes')"
    :rows="4"
    class="col-12"
  />
  <FormActions :on-submit="save" :on-cancel="cancel" />
</b-row>
